import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {PackingStatusType} from "../../types/packing-status.type";

export class PackingStatusesMultiSelectListComponent implements IController {
  packingStatuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(PackingStatusType));
    }
  }

  $onChanges(changes) {
    if (changes.packingStatuses) {
      this.selectedKeys = [];
      _.forEach(this.packingStatuses, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      packingStatuses: isSelected ? _.concat(this.packingStatuses, [option]) :
        _.filter(this.packingStatuses, (status) => {
          return status !== option;
        })
    });
  }

  onReset() {
    this.onChange({packingStatuses: []});
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('packingStatusesMultiSelectList', {
    bindings: {
      packingStatuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./packing-statuses-multi-select-list.html').default,
    controller: PackingStatusesMultiSelectListComponent
  });


